import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';
// Pyrana brand fonts (Geist + Geist Mono), bundled locally — no external CDN.
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
